import { Box } from "@primer/react";
import styles from "./TimeEdit.module.css"
import TextInput from "../ui/text-input";
import { useState } from "react";
interface ITimeEditProps {
    isNoborder?: boolean,
    value: string,
    onValueChanged: (value: string) => void
}
const TimeEdit = (props: ITimeEditProps) => {
    const [tempValue, setTempValue] = useState(props.value.length>5 ? props.value.substring(0,5): props.value);
    
    return (
        <Box className={props.isNoborder ? styles.noborder : ""}>
            <TextInput
                type="time"
                value={tempValue}
                autoFocus
                onChange={(e)=>{
                    setTempValue(e.target.value)
                }}
                onBlur={(e)=>{
                    props.onValueChanged(e.target.value)
                }}
            />
        </Box>
    );
};

export default TimeEdit;